<script setup lang="ts">
import { type Icon, isIcon } from '@/types/icon';

const props = defineProps<{
    icon: Icon;
}>();

const icon = computed<Component | undefined>(() => {
    if (!isIcon(props.icon)) {
        useLogger().error(`Icon ${props.icon as string} not found`);
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return defineAsyncComponent<Component>(async () => import(`@/assets/icons/${props.icon}.svg`));
});
</script>

<template>
    <component :is="icon" v-if="icon" />
</template>
